/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Event_Track_LabelInputs */



/**
* | output |
* | --- |
* | "Assign selected events to a track" |
*
* @param {Context_Menu_Event_Track_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_event_track_label = /** @type {((inputs?: Context_Menu_Event_Track_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Event_Track_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuer les événements sélectionnés à une piste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weisen Sie ausgewählte Ereignisse einer Spur zu.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna gli eventi selezionati a una traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Присвоить выбранным событиям трек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar eventos seleccionados a una pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定的事件分配到赛道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントをトラックに割り当てる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं को एक ट्रैक में असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribua os eventos selecionados a uma trilha.")
	return /** @type {LocalizedString} */ ("Assign selected events to a track")
});